import React, { useCallback, useContext } from 'react';

import {
  ExecutorList, ModalFormHeader, NoAssetsDisplay
} from '..';
import { ExecutorsContext } from '../../context';

export function WillExecutors() {
  const { executors } = useContext(ExecutorsContext);

  const handleRemoveExecutor = useCallback(() => {
    console.log('handleRemoveExecutor');
  }, []);
  
  return (
    <div className="form-container">
      <ModalFormHeader
        icon="groups"
        header="Executors"
      />
      { executors.length > 0 ? (
        <ExecutorList 
          executors={executors} 
          onRemove={handleRemoveExecutor} />
      ) : (
        <NoAssetsDisplay 
          compact
          icon="info" 
          title="No Executors" 
          description="Add individuals who will execute your will." />
      )}
    </div>
  );
}